var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('dialExpense',{attrs:{"recurrent":true,"title":"expenses_recurring"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }